/* eslint-disable react/jsx-boolean-value */
import React, { useState } from 'react';
import { Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import BadgeDetailsPopup from './BadgeDetailsPopup';
import BadgeAddNewPopup from './BadgeAddNewPopup';
import { getAllBadges, getBadgeTypeList } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import Image from '../common/Image';

const useStyles = makeStyles(() => ({
  container: {
    paddingTop: '24px',
    paddingLeft: '12px',
    paddingRight: '34px',
    paddingBottom: '24px',
    height: '65vh',
    width: '60vw',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  textImg: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '140%',
    color: '#1D2939',
    marginTop: '10px',
    marginBottom: '24px',
  },
}));

const BadgeContent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [selectedBadgeID, setSelectedBadgeID] = useState('');
  const [openBadgeDetails, setOpenBadgeDetails] = useState(false);
  const [openBadgeEdit, setOpenBadgeEdit] = useState(false);
  const selectedType = useSelector((state) => state.getSelectedBadgeType);
  const allbadges = useSelector((state) => state.getAllBadges.allbadges);
  const closePopup = () => {
    setOpenBadgeDetails(false);
  };
  const closeEditPopup = () => {
    setOpenBadgeEdit(false);
  };
  const openEditPopup = () => {
    setOpenBadgeEdit(true);
  };
  const deleteBadge = async () => {
    const con = window.confirm('Do you want to delete this badge?');
    if (con) {
      await service
        .delete(apiEndpoints.BADGES_UPDATE_BADGE.replace('BADGE_ID', selectedBadgeID))
        .then(() => {
          const payload = { id: selectedBadgeID };
          let tempSelectedType = '';
          if (selectedType === 'story') {
            tempSelectedType = 'dose';
          } else {
            tempSelectedType = selectedType;
          }
          dispatch(getAllBadges('remove', payload));
          dispatch(getBadgeTypeList('DecreaseBadgeCount', tempSelectedType.toLowerCase()));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const handleClick = (id) => {
    setSelectedBadgeID(id);
    setOpenBadgeDetails(true);
  };
  return (
    <Paper className={classes.container}>
      <Grid container direction="column" justifyContent="flex-start">
        <Grid item>
          <Grid container direction="row" justifyContent="flex-start">
            {allbadges?.map((item) => (
              <Grid
                item
                style={{
                  marginRight: '22px',
                  marginLeft: '22px',
                  cursor: 'pointer',
                }}
              >
                <Grid
                  container
                  direction="column"
                  onClick={() => {
                    handleClick(item.id);
                  }}
                >
                  <Grid item style={{ width: '70px' }}>
                    <Image
                      alt="logo"
                      style={{
                        width: '70px',
                        height: '77px',
                      }}
                      src={item.unlockedImageUrl}
                    />
                  </Grid>
                  <Grid item style={{ width: '70px' }}>
                    <Typography className={classes.textImg}>{item.name}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
      {openBadgeDetails && (
        <BadgeDetailsPopup close={closePopup} edit={openEditPopup} delete={deleteBadge} id={selectedBadgeID} />
      )}
      {openBadgeEdit && <BadgeAddNewPopup edit={true} close={closeEditPopup} id={selectedBadgeID} />}
    </Paper>
  );
};

export default BadgeContent;
